module.exports = __webpack_public_path__ + "static/img/bank@2x.9f71cc7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/bank@2x.png
// module id = qvIg
// module chunks = 1